import {
  escListener,
  debounce,
  scrollTo,
  scrollLock,
  setCookie,
  getCookie,
} from './utils'
import hcSticky from 'hc-sticky'
import loadingAttributePolyfill from 'loading-attribute-polyfill'

document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('screen and (min-width: 1024px)').matches) {
    new hcSticky('#main-collection-filters', {
      stickTo: '#main-collection-filters-container',
      top: 130,
    })
  }

  if (window.matchMedia('screen and (min-width: 1024px)').matches) {
    new hcSticky('.facets', {
      stickTo: '#shopify-section-collection-menu',
      top: 130,
    })
  }

  var stickyElements = [].slice.call(document.querySelectorAll('.sticky'))

  if ('IntersectionObserver' in window) {
    var stickyElementobserver = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
      { rootMargin: '-1px 0px 0px 0px', threshold: [1] }
    )

    stickyElements.forEach(function (stickyElement) {
      stickyElementobserver.observe(stickyElement)
    })
  }
})

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.getAttribute('id') !== 'collection-search')
        this.onSubmitHandler(event)
    }, 500)

    this.querySelector('form').addEventListener(
      'input',
      this.debouncedOnSubmit.bind(this)
    )

    const facetWrapper = this.querySelector('#FacetsWrapper')
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape)
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById('ProductCount')
    const countContainerDesktop = document.getElementById('ProductCountDesktop')
    document.getElementById('ProductGridContainer').classList.add('loading')
    if (countContainer) {
      countContainer.classList.add('loading')
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading')
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        document
          .getElementById('ProductGridContainer')
          .classList.remove('loading')
        scrollTo(document.querySelector('div.archive-grid__outer-container'))
        // FacetFiltersForm.renderProductCount(html);
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    document.getElementById('ProductGridContainer').classList.remove('loading')
    // FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML
    hidePromos()
    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('noscript.loading-lazy')
      .forEach((image) => {
        loadingAttributePolyfill.prepareElement(image)
      })
    lazyLoad()
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount')
    const containerDesktop = document.getElementById('ProductCountDesktop')
    container.innerHTML = count
    container.classList.remove('loading')
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove('loading')
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    )
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    )
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest('.js-filter')
      )
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.facets__active']

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected')
    const sourceElement = source.querySelector('.facets__selected')

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const formData = new FormData(event.target.closest('form'))
    const searchParams = new URLSearchParams(formData).toString()
    FacetFiltersForm.renderPage(searchParams, event)
    //console.log(searchParams);
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1
          )
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define('facet-filters-form', FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    )

    this.setMinAndMaxValues()
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input')
    const minInput = inputs[0]
    const maxInput = inputs[1]
    if (maxInput.value) minInput.setAttribute('max', maxInput.value)
    if (minInput.value) maxInput.setAttribute('min', minInput.value)
    if (minInput.value === '') maxInput.setAttribute('min', 0)
    if (maxInput.value === '')
      minInput.setAttribute('max', maxInput.getAttribute('max'))
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault()
      const form =
        this.closest('facet-filters-form') ||
        document.querySelector('facet-filters-form')
      form.onActiveFilterClick(event)

      //unselect checkbox
      form.querySelectorAll('input').forEach((input) => {
        if (
          event.target
            .closest('.facets__remove-filter')
            .querySelector('span')
            .textContent.trim() === input.value
        )
          input.checked = false
        if (
          event.target
            .closest('.facets__remove-filter')
            .querySelector('span')
            .textContent.trim() === 'Clear all'
        )
          input.checked = false
      })
      form.querySelectorAll('select').forEach((select) => {
        if (event.target.textContent.trim() === select.value)
          select.value = select.querySelector('option:first-child').textContent
        if (event.target.textContent.trim() === 'Clear all')
          select.value = select.querySelector('option:first-child').textContent
      })
    })
  }
}

customElements.define('facet-remove', FacetRemove)

// filters
const hidePromos = () => {
  const productLength = document.querySelectorAll(
    '#ProductGridContainer .card'
  ).length
  if (productLength < 6)
    document
      .querySelectorAll('.promo--large')
      .forEach((el) => (el.style.display = 'none'))
  if (productLength < 13)
    document
      .querySelectorAll('.promo--small')
      .forEach((el) => (el.style.display = 'none'))
}

hidePromos()

//image lazyload
const lazyLoad = () => {
  var lazyImages = [].slice.call(document.querySelectorAll('img'))

  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
    let lazyImageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target
          if (!lazyImage.classList.contains('loaded')) {
            lazyImage.classList.add('loaded')
            observer.unobserve(lazyImage)
          }
        }
      })
    })

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage)
    })
  }
}

document.querySelectorAll('.archive-grid').forEach((archiveGrid) => {
  let filtersOpen = false
  let toggleFiltersButton = archiveGrid.querySelector('.toggle-filtering')
  let filtersContainer = archiveGrid.querySelector(
    '.archive-grid__filters-container'
  )

  let closeFilters = () => {
    filtersOpen = false
    archiveGrid.classList.remove('archive-grid__main-container--filters-hidden')
    toggleFiltersButton.classList.toggle('filters-off')
    scrollLock(false)
  }

  toggleFiltersButton.addEventListener('click', () => {
    if (filtersOpen) {
      escListener(false)
      closeFilters()
    } else {
      archiveGrid.classList.add('archive-grid__main-container--filters-hidden')
      toggleFiltersButton.classList.toggle('filters-off')
      filtersOpen = true
      escListener(true, closeFilters)

      // should be only on mobile
      if (window.matchMedia('screen and (max-width: 767px)').matches) {
        scrollLock(true)
      }
    }
  })

  filtersContainer.addEventListener('click', (e) => {
    if (e.target === filtersContainer) {
      escListener(false)
      closeFilters()
    }
  })

  filtersContainer
    .querySelector('.facets__mobile-close')
    .addEventListener('click', () => {
      escListener(false)
      closeFilters()
    })
})

document
  .querySelector('.facets__form .available-online')
  .addEventListener('change', (e) => {
    document.querySelector(
      '.archive-grid__filter-triggers .available-online'
    ).checked = e.target.checked
  })

document
  .querySelector('.archive-grid__filter-triggers .available-online')
  .addEventListener('click', (e) => {
    document.querySelector('.facets__form .available-online').click()
  })

//Update column count
var el = document.querySelector('.archive-grid__content')

document.querySelector('.three-col').onclick = function () {
  el.classList.remove('archive-grid__content--four-col')
  el.classList.add('archive-grid__content--three-col')
  document.querySelector('.four-col').classList.remove('active')
  document.querySelector('.three-col').classList.add('active')
  setCookie('product-grid-cols', '3', 1)
}

document.querySelector('.four-col').onclick = function () {
  el.classList.remove('archive-grid__content--three-col')
  el.classList.add('archive-grid__content--four-col')
  document.querySelector('.three-col').classList.remove('active')
  document.querySelector('.four-col').classList.add('active')
  setCookie('product-grid-cols', '4', 1)
}

document.querySelector('.one-col').onclick = function () {
  el.classList.remove('archive-grid__content--two-col')
  el.classList.add('archive-grid__content--one-col')
  document.querySelector('.two-col').classList.remove('active')
  document.querySelector('.one-col').classList.add('active')
  setCookie('product-grid-mobile-cols', '1', 1)
}

document.querySelector('.two-col').onclick = function () {
  el.classList.remove('archive-grid__content--one-col')
  el.classList.add('archive-grid__content--two-col')
  document.querySelector('.one-col').classList.remove('active')
  document.querySelector('.two-col').classList.add('active')
  setCookie('product-grid-mobile-cols', '2', 1)
}

if (getCookie('product-grid-cols') == 4) {
  el.classList.remove('archive-grid__content--three-col')
  el.classList.add('archive-grid__content--four-col')
  document.querySelector('.three-col').classList.remove('active')
  document.querySelector('.four-col').classList.add('active')
}

if (getCookie('product-grid-mobile-cols') == 1) {
  el.classList.remove('archive-grid__content--two-col')
  el.classList.add('archive-grid__content--one-col')
  document.querySelector('.two-col').classList.remove('active')
  document.querySelector('.one-col').classList.add('active')
}

document.querySelectorAll('.truncatable').forEach((truncatable) => {
  if (truncatable.offsetHeight < truncatable.scrollHeight) {
    truncatable.classList.add('truncated')
    //console.log('offset:' + truncatable.offsetHeight);
    //console.log('scroll:' + truncatable.scrollHeight);
  }
})

document.querySelectorAll('.expand').forEach((truncatedOpener) => {
  truncatedOpener.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    truncatedOpener.parentNode.classList.add('expanded')
  })
})

document.querySelectorAll('.shrink').forEach((truncatedCloser) => {
  truncatedCloser.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    truncatedCloser.parentNode.classList.remove('expanded')
  })
})
